/** Retardo por defecto al abrir con `openOnHover={true}` (ms). */
export const POPUP_OPEN_ON_HOVER_DEFAULT_MS = 200;
/** Margen al salir del trigger o del panel antes de cerrar (ms). */
export const POPUP_OPEN_ON_HOVER_CLOSE_DELAY_MS = 100;

export function isOpenOnHoverEnabled(value: boolean | number | undefined): boolean {
  return value === true || typeof value === 'number';
}

export function getOpenOnHoverDelayMs(value: true | number): number {
  if (value === true) {
    return POPUP_OPEN_ON_HOVER_DEFAULT_MS;
  }
  return Math.max(0, value);
}
